export const isLoggedIn = window.localStorage.getItem('app_isLoggedIn')
